// import chain from 'lodash/chain';
import _ from 'lodash';

// import findIndex from 'lodash/findIndex';
// import mixin from 'lodash/mixin';
// import _ from 'lodash/wrapperLodash';

// mixin(_, {
//   chain: chain,
//   findIndex: findIndex
// });

const arrayPosition = (array, current) => {
  const flattenArray = (data, key) => {
    return _.chain(data).map(key).flatten().value();
  };
  const flattened = flattenArray(flattenArray(array), 'urls');
  const position = _.findIndex(flattened, {id: current});
  return position;
};

export default arrayPosition;



// WEBPACK FOOTER //
// ./src/scripts/array-postion.js